import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import SvgLoadingAnimation from "../../components/loading/index";
import { useGetNotesTreeQuery } from "../../app/services/notes";
import { UPDATE_INFO_SECTION_TITLE } from "../../constant/updateInfo";

/**
 * 旧 `/updateinfo`（Django SSR のアップデート情報）の SPA 側受け口。
 *
 * アップデート情報は共有ノートの公開セクション（タイトル
 * `UPDATE_INFO_SECTION_TITLE`）へ移行したため、ここでは公開ツリーから
 * 該当セクションを探して `/notes` へリダイレクトするだけ。
 * セクションが見つからない（未移行・非公開化）場合は `/notes` トップへ送る。
 */

const UpdateInfoRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { data, isSuccess, isError } = useGetNotesTreeQuery();

  useEffect(() => {
    if (isError) {
      navigate("/notes", { replace: true });
      return;
    }
    if (!isSuccess) return;

    const section = data?.data.sections.find(
      (s) => s.title === UPDATE_INFO_SECTION_TITLE,
    );
    if (!section) {
      navigate("/notes", { replace: true });
      return;
    }

    const query = `?section=${encodeURIComponent(section.id)}`;
    const firstNote = [...section.notes]
      .filter((n) => n.display_style === "note")
      .sort((a, b) => a.sort_order - b.sort_order)[0];
    navigate(
      firstNote ? `/notes/${firstNote.id}${query}` : `/notes${query}`,
      { replace: true },
    );
  }, [data, isSuccess, isError, navigate]);

  return <SvgLoadingAnimation />;
};

export default UpdateInfoRedirect;
